import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do I need to be in shape before starting?",
    a: "No. Coach Manny works with every level — from complete beginners to experienced athletes. Every session is built around where you are today.",
  },
  {
    q: "Can I train online if I live outside Idaho?",
    a: "Yes. Online coaching is a core service. You'll get personalised programming, check-ins, and live video sessions that fit your schedule.",
  },
  {
    q: "Do you coach kids and youth soccer players?",
    a: "Yes. Youth athlete development is a big part of what we do — focused on technique, confidence, and long-term growth.",
  },
  {
    q: "How long are sessions and how often should I train?",
    a: "Sessions typically run 45–60 minutes. Most clients train 2–4 times per week depending on their goals. We'll map it out in your free consultation.",
  },
  {
    q: "How do I get started?",
    a: "Book a free consultation using the form above, or call (208) 901-9386. Coach Manny will reach out within 24 hours.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section border-t border-white/10 bg-[#0f0f0f]"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
            / 06 — FAQ
          </div>
          <h2
            data-testid="faq-title"
            className="font-display text-5xl md:text-6xl uppercase leading-[0.95] tracking-tight"
          >
            Questions,
            <br />
            answered.
          </h2>
          <p className="text-white/60 mt-6 max-w-sm">
            Still not sure? Call Coach Manny directly — no pressure.
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-lg md:text-xl font-medium text-white hover:text-[#FF3B30] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/70 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
